import Vue from 'vue';
import Router from 'vue-router';

import yzheader from '../components/common/yzheader.vue';
import yzfooter from '../components/common/yzfooter.vue';

import cz from '../components/cz';
import parkservice from '../components/parkservice';
import platformservice from '../components/platformservice';
import shopservice from '../components/shopservice.vue';
import aboutus from '../components/aboutus';
import scanin from '../components/scanin';
import scanout from '../components/scanout';
import home1 from '../components/home1';
import articledetaile from '../components/articledetaile';
import allnews from '../components/allnews';
import login from '../components/login';
import announcement from '../components/announcement'
import community from '../components/community';
import government from '../components/government';
import information from '../components/information';
Vue.use (Router);

export default new Router ({
  routes: [
    {
      path: '/announcement',
      component: announcement,
      meta: {
        headershow: false, // true显示，false隐藏
      },
    },
    {
      path: '',
      component: home1,
    },
    {
      path: '/community',
      component: community,
    },
    {
      path: '/information',
      component: information,
    },
    {
      path: '/government',
      component: government,
    },
    {
      path: '/parkservice',
      component: parkservice,
    },
    {
      path: '/platformservice',
      component: platformservice,
    },
    {
      path: '/shopservice',
      component: shopservice,
    },
    {
      path: '/aboutus',
      component: aboutus,
    },
    {
      path: '/scanin',
      component: scanin,
    },
    {
      path: '/scanout',
      component: scanout,
    },
    {
      path: '/cz',
      component: cz,
    },
    {
      path: '/home1',
      component: home1,
      meta: {
        headershow: false, // true显示，false隐藏
      },
    },
    {
      path: '/articledetaile',
      component: articledetaile,
    },
    {
      path: '/allnews',
      component: allnews,
    },
    {
      path: '/login',
      component: login,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js